import AuthUtils from 'utils/AuthUtils'

import { clearSsoSession, getSsoSession } from './flow-store'
import { generateState } from './pkce'
import { trackSsoEvent } from './telemetry'

/**
 * Signs out locally FIRST, then (best-effort) redirects to the IdP's
 * end-session endpoint. If the IdP never redirects back, the user is already
 * logged out locally — there is no in-progress flag to strand and nothing for
 * the next login to race against.
 */
export const ssoV2SignOut = async ({
  isLoginAs
}: { isLoginAs?: boolean } = {}): Promise<void> => {
  const session = getSsoSession()

  await AuthUtils.signOut()
  clearSsoSession()

  trackSsoEvent('sso_logout_local', { provider_slug: session?.provider_slug })

  if (!session?.logout_uri) return

  if (isLoginAs && session.skip_login_as_logout) return

  const logoutUrl = new URL(session.logout_uri)

  if (session.client_id) {
    logoutUrl.searchParams.set('client_id', session.client_id)
  }

  if (session.logout_redirect_uri) {
    logoutUrl.searchParams.set(
      'post_logout_redirect_uri',
      session.logout_redirect_uri
    )
  }

  if (session.id_token) {
    logoutUrl.searchParams.set('id_token_hint', session.id_token)
  }

  logoutUrl.searchParams.set('state', generateState())

  trackSsoEvent('sso_logout_idp_redirect', {
    provider_slug: session.provider_slug
  })

  window.location.assign(logoutUrl.toString())
}

/** Whether the current session was established via the new SSO flow. */
export const hasSsoV2Session = (): boolean => !!getSsoSession()
